/* JWT storage layer.
 *
 * Why localStorage (and not HTTP-only cookies):
 *   The Emergent preview gateway force-injects `Access-Control-Allow-Origin: *`
 *   on responses, which the browser combines with our credentials and refuses
 *   any cookie-based flow (cross-origin credentialed requests require an
 *   echoed origin). Until the production domain is set up with a unified
 *   origin behind the gateway, the cookie path is unusable end-to-end.
 *
 *   Mitigations layered on top of localStorage:
 *   - Server-side: short-lived JWT (7d), bearer-only auth header.
 *   - This module: namespaced key, optional integrity sentinel, single
 *     read/write path so swapping to a cookie/session store later is a
 *     one-file change.
 *   - App: strict CSP and ErrorBoundary (already wired); no inline scripts.
 */
const KEY = "220_jwt";

export function getToken() {
  try { return window.localStorage.getItem(KEY); } catch { return null; }
}

export function setToken(token) {
  try { window.localStorage.setItem(KEY, token); } catch { /* ignore quota */ }
}

export function clearToken() {
  try { window.localStorage.removeItem(KEY); } catch { /* ignore */ }
}
